module.exports = __webpack_public_path__ + "static/media/activation_code_back.de0dffdf.png";